/* eslint-disable react-hooks/rules-of-hooks */
import { useUserSelector } from '@/redux/userSlice'
import { useEffect } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { getQueryParameter } from '@/utils'
const redirectUri = getQueryParameter(window.location.href, 'redirect_uri') || ''
interface LoginAuthProps {
  children: JSX.Element
}

const whitePathName = ['/login', '/dashboard/loading']

export const LoginAuth = (props: LoginAuthProps) => {
  const { token } = useUserSelector()
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const loginType = localStorage.getItem('loginType')
  const accountType = localStorage.getItem('account_type')
  const { log } = console
  useEffect(() => {
    if (pathname.includes('/maintenance')) {
      navigate('/maintenance')
      return
    } else {
      if (!token && !whitePathName.includes(pathname) && !pathname.includes('maintenance')) {
        navigate('/login')
      }
      if (token && whitePathName.includes(pathname) && !pathname.includes('maintenance')) {
        if (loginType === 'sub-account' || accountType === '2') {
          navigate(`/easm/overview`)
        } else {
          navigate(redirectUri ? redirectUri : `/overview/dashboard`)
        }
      }
    }
  }, [token])

  if (!token && !whitePathName.includes(pathname) && !pathname.includes('/maintenance')) {
    navigate('/login')
  }

  return props.children
}
